export const tabsData = [
    { title: "All"},
    { title: "New"},
    { title: "UI Kit"},
    { title: "Website"},
    { title: "Mobile"},
    { title: "Illustrations"},
    { title: "Icons"},
]